import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RoutingIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 2C5 1.44772 4.55228 1 4 1H2C1.44772 1 1 1.44772 1 2V4C1 4.55228 1.44772 5 2 5H4C4.55228 5 5 4.55228 5 4V2Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 4.24988C6.15698 4.45881 6.25 4.71854 6.25 5V11C6.25 12.5188 7.48122 13.75 9 13.75H10V12.25H9C8.30964 12.25 7.75 11.6904 7.75 11V8.45015C8.12503 8.64186 8.54989 8.75 9 8.75H10V7.25H9C8.30964 7.25 7.75 6.69036 7.75 6V5C7.75 3.83401 7.02434 2.8375 6 2.43747V4.24988Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11 7C11 6.44772 11.4477 6 12 6H14C14.5523 6 15 6.44772 15 7V9C15 9.55229 14.5523 10 14 10H12C11.4477 10 11 9.55229 11 9V7Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11 12C11 11.4477 11.4477 11 12 11H14C14.5523 11 15 11.4477 15 12V14C15 14.5523 14.5523 15 14 15H12C11.4477 15 11 14.5523 11 14V12Z"
		></path>
	</svg>
))
